import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { VisuallyHidden } from 'components/ucl/visually-hidden';

import ProgressBar from '../progress-bar/progress-bar';
import ProgressCheckpoint from '../progress-bar/progress-checkpoint';
import { ProgressList, ProgressListItemHeader } from '../progress-bar/styled';

interface IOrderConfirmationHeaderProgressProps {
  needConfirm?: boolean;
}

const OrderConfirmationHeaderProgress: React.FC<React.PropsWithChildren<
  IOrderConfirmationHeaderProgressProps
>> = ({ needConfirm }) => {
  const { formatMessage } = useIntl();
  const percentComplete = needConfirm ? 0 : 100;
  const isOrderPrepared = !needConfirm;

  const ariaLabel = () => {
    const [complete, incomplete] = [
      formatMessage({ id: 'complete' }),
      formatMessage({ id: 'incomplete' }),
    ];
    return `
      ${formatMessage({ id: 'orderCreated' })} ${complete},
      ${formatMessage({ id: 'ConfirmImHere' })} ${isOrderPrepared ? complete : incomplete},
      ${formatMessage({ id: 'orderPrepared' })} ${isOrderPrepared ? complete : incomplete},
    `;
  };

  return (
    <Box>
      <VisuallyHidden role="alert" accessibilityLabel={ariaLabel()} />
      <ProgressBar percentComplete={percentComplete} styles={{ top: '$7' }} whiteVariant />
      <ProgressList>
        <ProgressListItemHeader isActive>
          <ProgressCheckpoint whiteVariant isActive />
          {formatMessage({ id: 'orderCreated' })}
        </ProgressListItemHeader>
        <ProgressListItemHeader isActive={isOrderPrepared}>
          <ProgressCheckpoint whiteVariant isActive={isOrderPrepared} />
          {formatMessage({ id: 'ConfirmImHere' })}
        </ProgressListItemHeader>
        <ProgressListItemHeader isActive={isOrderPrepared}>
          <ProgressCheckpoint whiteVariant isActive={isOrderPrepared} />
          {formatMessage({ id: 'orderPrepared' })}
        </ProgressListItemHeader>
      </ProgressList>
    </Box>
  );
};

export default OrderConfirmationHeaderProgress;
